import { S as STORAGE_KEY, B as BROADCAST_CHANNEL_KEY } from '../../constants-BAsg3-1S.js';

/**
 * Updates the theme mode preference and broadcasts the change across tabs.
 * Stores the preference in localStorage and notifies other application instances via BroadcastChannel.
 *
 * @param value - The theme mode preference to set (light, dark, or system)
 */
var setThemeMode = value => {
  localStorage.setItem(STORAGE_KEY, value);

  // Broadcast the change
  try {
    const channel = new BroadcastChannel(BROADCAST_CHANNEL_KEY);
    channel.postMessage(value);
    channel.close();
  } catch (error) {
    console.warn('BroadcastChannel API not supported', error);
  }
};

export { setThemeMode as s };
//# sourceMappingURL=setThemeMode-cd7Qb3dS.js.map
